import styled from "styled-components";
import { BORDER_RADIUS } from "variables/spacing";

export const RoundedCard = styled.div`
  border-radius: ${BORDER_RADIUS} !important;
`;
